import apiClient from './apiClient';
import type { ApiRequestOptions } from './apiClient';

export interface DirectoryPreference {
  event_id: string;
  show_in_directory: boolean;
  visible: boolean;
  moderator_hidden: boolean;
  updated_at: string;
}

export const directoryPrivacyService = {
  getDirectoryPreference(
    eventId: string,
    options: ApiRequestOptions = {},
  ): Promise<DirectoryPreference> {
    return apiClient.get<DirectoryPreference>(
      `/events/${encodeURIComponent(eventId)}/me/directory-preference`,
      options,
    );
  },

  setDirectoryPreference(
    eventId: string,
    showInDirectory: boolean,
    options: ApiRequestOptions = {},
  ): Promise<DirectoryPreference> {
    return apiClient.put<DirectoryPreference>(
      `/events/${encodeURIComponent(eventId)}/me/directory-preference`,
      { show_in_directory: showInDirectory },
      options,
    );
  },
};
